import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { postMyContract, tradeHistoryCall } from "../../crud/auth.crud"
import Util from "pages/Dashboard/Common/Util";
import Modal from "components/RopikCustom/Modal";
import Pagination from "pages/Custom/Pagination";

import Default from "assets/images/default.png";
import Loading from "pages/Custom/Loading";

const newDate = new Date()

// 드롭다운 map용
const currentYear = parseInt(moment().format("YYYY"), 10);
const yearSelect = Array.from({ length: 4 }, (_, i) => currentYear - i);
const monthSelect = [
  ...Array(12).keys()
].map(x => x + 1)

const TradeHistory = () => {
  const location = useLocation()
  const history = useHistory()
  const queryParams = new URLSearchParams(location.search)
  const page = queryParams.get('page') || 1
  const year = queryParams.get('year') || moment(newDate).format("YYYY")
  const month = queryParams.get('month') || ''
  const companyId = useSelector(state => 
    state.auth?.user?.member_group?.[0]?.company_group?.id || null
  );

  const [dataList, setDataList] = useState([]);
  const [pricePerL, setPricePerL] = useState(170);
  const [onUpload, setOnUpload] = useState(false);
  const [selectedItem, setSelectedItem] = useState({})
  const [modalShow, setModalShow] = useState(false)
  const [totalDataCount, setTotalDataCount] = useState(0)

  const handleYearClick = (e) => {
    const value = e.target.value
    queryParams.set("year", String(value))
    queryParams.set("month", '')
    queryParams.set("page", '1')
    const url = `${location.pathname}?${queryParams.toString()}`
    history.push(url)
  }

  const handleMonthClick = (e) => {
    const value = String(e.target.value).padStart(2, '0');
    queryParams.set("month", String(value))
    queryParams.set("page", '1')
    const url = `${location.pathname}?${queryParams.toString()}`
    history.push(url)
  }

  const getDataList = async () => {
    setOnUpload(true)
    let start_ym = month ? year + '-' + month + '-01' : year + '-01-01';
    let newDate = new Date(start_ym)
    let end_ym = month ? moment(newDate.setMonth(newDate.getMonth() + 1)).format("YYYY-MM") + '-01' : (parseInt(year) + 1) + '-01-01';
    const params = {
      company: companyId,
      start_ym,
      end_ym,
      page: page
    }
    const response = await tradeHistoryCall(params)
    setTotalDataCount(response.data.count || 0)
    const content = response.data?.results || []
    setDataList(content)
    setOnUpload(false)
  }

  const getMyContract = async () => {
    try {
      const params = {
        ids: JSON.stringify([companyId]),
      }
      const response = await postMyContract(params);
      if (response.data?.result === 'success') {
        const dataList = response?.data?.data;
        for(let i=0; i< dataList.length; i++){
          const data = dataList[i]
          if(['collection', 'emitter'].includes(data.contract_company_group_data.type)){
            setPricePerL(data?.contract_group_data.price_per_l || 170)
            break                                       
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const modalClose = () => {
    setModalShow(false);
  }

  useEffect(() => {
    getDataList()
  }, [page, year, month])

  useEffect(() => {
    getMyContract()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>수거내역 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="관리대장" breadcrumbItem="수거내역" />

          <div>
            <select id="yearselect" name="yearselect" className='dropdown-toggle waves-effect waves-light mb-4 waver-select-box' disabled={onUpload} value={year} onChange={(e) => {
              handleYearClick(e)
            }}>
              {yearSelect.map((item, index) => {
                return (
                  <option key={index} value={item}>{item + "년"}</option>
                )
              })}
            </select>
            <select id="monthselect" name="monthselect" className='dropdown-toggle waves-effect waves-light waver-select-box' style={{ marginLeft: 16}} disabled={onUpload} value={String(parseInt(month, 10))} onChange={(e) => {
              handleMonthClick(e)
            }}>
              <option value=''>전체</option>
              {monthSelect && monthSelect.map((item, index) => {
                return (
                  <option key={index} value={item}>{item + "월"}</option>
                )
              })}
            </select>
          </div>

          <Row>
            <Col xs="12">
              {/* Render Email SideBar */}
              {/* <EmailSideBar /> */}
              <div className="email-rightbar mb-3">
                <Card>
                  <CardBody style={{padding: 0, borderRadius: 4, overflow: 'hidden'}}>                    
                    <div className="table-responsive">
                      <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                        <thead className="chart-thead">
                          <tr>
                            <th scope="col">ID</th>
                            <th scope="col">수거업체명</th>
                            <th scope="col">차량번호</th>
                            <th scope="col">쓰레기통</th>
                            <th scope="col">수거일자</th>
                            <th scope="col">정산금액(원)</th>
                            <th scope="col">수거량(L)</th>
                          </tr>
                        </thead>
                        <tbody className="chart-tbody">
                          {dataList.map((item, index) => {
                            return (
                              <tr className="pointer" key={item.id + '_' + index} onClick={()=>{
                                setSelectedItem(item)
                                setModalShow(true)
                              }}>
                                <td>{item.id}</td>
                                <td>{item.driver_company_data?.name}</td>
                                <td>{item.car_data?.number || '차량번호없음'}</td>
                                <td>{item.state === 'N' ? item.memo : item.rf_id}</td>
                                <td>{item.created_at.substr(0, 10)}</td>
                                <td>{Util.setCommaPrice(item.qty * pricePerL)}</td>
                                <td>{item.state === 'N' ? '미수거' : Util.setCommaPrice(item.qty)}</td>
                              </tr>
                            )
                          })
                          }
                          {dataList.length === 0 &&
                            <tr >
                              <td scope="row" colSpan="7">데이터가 없습니다.</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                  {onUpload && <Loading />}
                </Card>
                <Pagination totalDataCount={totalDataCount} isLoading={onUpload} />
              </div>
            </Col>
          </Row>
          <Modal title={'상세보기'} show={modalShow} onHide={modalClose} size="md">
            <div style={{ zIndex: 1, minHeight : '300px', width: '100%', display: "flex", justifyContent: "center", flexDirection: 'column' }}>
              <p style={{fontSize: '1rem', textAlign: 'center'}}>{selectedItem.name}</p>
              <img style={{
                margin: '0 auto',
                width: 382,
              }}
              src={ Util.addHostUrl(selectedItem?.waste_collect_file?.[0]?.path) }
              onError={(e) => e.target.src = Default} />
            </div>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default TradeHistory
